import { type BioV2_userProfile$key } from '#app/__generated__/relay/BioV2_userProfile.graphql.js';
import { BioTextRegular } from './BioV2.styles.js';
import { BioV2VisitorCanEdit } from './BioV2VisitorCanEdit.js';
import { graphql, useFragment } from '@contra/relay';
import { Suspense } from 'react';

type BioV2Props = {
  readonly userProfileRef: BioV2_userProfile$key;
};

const PublicBio = ({ bio }: { readonly bio: null | string }) => {
  if (!bio) return null;

  return <BioTextRegular>{bio}</BioTextRegular>;
};

export const BioV2 = ({ userProfileRef }: BioV2Props) => {
  const data = useFragment<BioV2_userProfile$key>(
    graphql`
      fragment BioV2_userProfile on UserProfile {
        bio
        visitorCanEdit
      }
    `,
    userProfileRef,
  );

  const { bio, visitorCanEdit } = data;

  const publicBio = <PublicBio bio={bio} />;

  if (visitorCanEdit) {
    return (
      <Suspense fallback={publicBio}>
        <BioV2VisitorCanEdit bio={bio} />
      </Suspense>
    );
  }

  return publicBio;
};
